<section class="card p-4 mt-4 pdv-panel" aria-labelledby="pdv-origin-title">
  <div class="pdv-panel__header"><h2 id="pdv-origin-title" class="pdv-panel__title">Origem das vendas</h2></div>
  <p class="pdv-panel__description">
    A maquininha é registrada em cada venda, não no caixa. Esta consulta considera o evento inteiro, independentemente
    dos filtros de caixa acima.
  </p>
  <div class="pdv-panel__filters pdv-panel__filters--terminal">
    <label class="pdv-panel__field"
      >Maquininha
      <select class="form-select" [formControl]="terminal" [attr.aria-busy]="loading()">
        <option value="">Todas as maquininhas</option>
        @for (item of terminals(); track item.id) {
          <option [value]="item.id">{{ item.name || item.id }}</option>
        }
        @if (hasUnidentified() || terminal.value === "__unidentified__") {
          <option value="__unidentified__">Não identificada</option>
        }
      </select>
    </label>
    <div class="pdv-panel__filter-action">
      <app-button styleType="outlined" icon="pi pi-refresh" [disabled]="loading()" (btnClick)="load()"
        >Atualizar vendas</app-button
      >
    </div>
  </div>
  <p class="pdv-panel__note">
    <i class="pi pi-info-circle" aria-hidden="true"></i
    ><span
      >Vendas anteriores à identificação ou de aplicativos que não a informam aparecem como “Não identificada”.
      “Instalação” identifica o app instalado, não garante o aparelho físico.</span
    >
  </p>
  @if (loading()) {
    <p role="status" class="pdv-panel__message">Carregando origem das vendas…</p>
  }
  @if (error()) {
    <p role="alert" class="pdv-panel__error">{{ error() }}</p>
  }
  @if (result(); as data) {
    <div class="pdv-panel__summary">
      <span>Total de pedidos pagos no filtro</span
      ><strong class="pdv-panel__total">{{ data.total_paid_cents / 100 | currency: "BRL" }}</strong>
    </div>
    <div class="pdv-panel__table" role="region" aria-label="Origem das vendas" tabindex="0">
      <p-table [value]="data.data" [scrollable]="true" [stripedRows]="true" [tableStyle]="{ 'min-width': '65rem' }">
        <ng-template pTemplate="header"
          ><tr>
            <th>Pedido</th>
            <th>Data</th>
            <th>Maquininha</th>
            <th>Operador</th>
            <th>Sessão</th>
            <th>Fase</th>
            <th>Pagamento</th>
            <th>Status</th>
            <th class="pdv-panel__money">Valor</th>
          </tr></ng-template
        >
        <ng-template pTemplate="body" let-row>
          <tr>
            <td class="pdv-panel__identifier">#{{ row.order_id }}</td>
            <td class="pdv-panel__nowrap">{{ row.created_at | date: "dd/MM/yyyy HH:mm" }}</td>
            <td [title]="row.terminal?.id || ''">
              {{ row.terminal ? row.terminal.name || row.terminal.id : "Não identificada" }}
            </td>
            <td>{{ row.operator_name }}</td>
            <td class="pdv-panel__identifier">#{{ row.session_id }}</td>
            <td>{{ row.sales_phase === "advance" ? "Antecipados" : "Portaria" }}</td>
            <td>{{ paymentNames[row.payment_method] || row.payment_method }}</td>
            <td>
              <span class="pdv-panel__badge" [class.pdv-panel__badge--success]="row.payment_status === 'paid'">{{
                statusNames[row.payment_status] || row.payment_status
              }}</span>
            </td>
            <td class="pdv-panel__money">{{ row.total_amount | currency: "BRL" }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage"
          ><tr>
            <td colspan="9" class="pdv-panel__empty">Nenhuma venda encontrada.</td>
          </tr></ng-template
        >
      </p-table>
    </div>
    <div class="pdv-panel__pagination">
      <app-button
        styleType="outlined"
        [disabled]="loading() || data.meta.current_page <= 1"
        (btnClick)="load(data.meta.current_page - 1)"
        >Anterior</app-button
      >
      <span
        >Página {{ data.meta.current_page }} de {{ data.meta.total_pages || 1 }} ·
        {{ data.meta.total_count }} pedidos</span
      >
      <app-button
        styleType="outlined"
        [disabled]="loading() || data.meta.current_page >= data.meta.total_pages"
        (btnClick)="load(data.meta.current_page + 1)"
        >Próxima</app-button
      >
    </div>
  }
</section>
